import Dexie from 'dexie';

export interface QSheetRecord {
  tab_id: string;
  ref_id: string;
  from: 'editor' | 'para';
  sheetData: {
    group_uuid: string;
    workspace_id?: string;
    paragraph?: boolean;
    upload_data: {
      last_saved_at?: number;
      last_modified_at?: number;
      catalog?: unknown;
      cluster?: unknown;
      database?: unknown;
      order_by?: number;
      uuid?: string;
      queries:
        | {
            ref_id: string;
            query?: string;
            para_index?: number;
            uuid?: string;
            s3_key?: string;
            start_time?: number;
            name?: string;
          }
        | {
            ref_id: string;
            query?: string;
          }[];
    };
  };
}

export interface QSheetsMetaRecord {
  from: 'editor' | 'para';
  workspace_id?: string;
  meta: {
    active?: string;
    meta_uuid?: string;
    last_saved_at?: number;
    last_modified_at?: number;
    [tabId: string]: unknown;
  };
}

export interface UILogRecord {
  id?: number;
  Value?: unknown;
  type?: string;
  message?: string;
  timestamp?: number;
  [key: string]: unknown;
}

// Typed Dexie database subclass
class E6Database extends Dexie {
  qSheets!: Dexie.Table<QSheetRecord, [string, string]>;
  qSheetsMeta!: Dexie.Table<QSheetsMetaRecord, string>;
  ui_logs!: Dexie.Table<UILogRecord, number>;

  constructor() {
    super('e6data');

    // always change version when making changes in current schema
    this.version(1).stores({
      qSheets: '[tab_id+ref_id],from, sheetData',
    });
    this.version(2).stores({
      qSheets: '[tab_id+ref_id],from, sheetData',
      qSheetsMeta: '[workspace_id+from], meta',
    });
    this.version(3).stores({
      qSheets: '[tab_id+ref_id],from, sheetData',
      qSheetsMeta: '[workspace_id+from], meta',
      ui_logs: '++id, Value',
    });
    // v4: Delete qSheetsMeta to prepare for primary-key change.
    // Dexie cannot change a store's primary key in place (throws UpgradeError
    // "Not yet support for changing primary key"). The only supported path is
    // null the store in one version and recreate it with the new schema in the
    // next. The old meta is UI state (active tab / timestamps) and is
    // regenerated on next use, so data loss is acceptable.
    this.version(4).stores({
      qSheets: '[tab_id+ref_id],from, sheetData',
      qSheetsMeta: null,
      ui_logs: '++id, Value',
    });
    // v5: Recreate qSheetsMeta with flattened single-PK structure.
    this.version(5).stores({
      qSheets: '[tab_id+ref_id],from, sheetData',
      qSheetsMeta: 'from, meta',
      ui_logs: '++id, Value',
    });
  }
}

export const db = new E6Database();
